type IUnitToName = Record<string, string>;

export const unitToName: IUnitToName = {
  mbar: "mB",
  pascal: "Pa",
  kPa: "kPa",
  MPa: "MPa",
  hPa: "hPa",
  Torr: "Torr",
  psi: "psi",
  celsius: "°C",
  fahrenheit: "°F",
  kelvin: "°K",
};
